import { palette } from '../theme/palette';
import { styled, Typography } from '@mui/material';

/*
 Titles
*/

export const BaseTitle = styled(Typography)`
  color: ${palette.custom.darkGrey};
  text-transform: uppercase;
  font-weight: 800;
  font-family: trade-gothic-next-condensed, sans-serif;
  margin-bottom: 4px;
  width: fit-content;
`;

export const Title = styled(BaseTitle)`
  font-size: 20px;
`;

export const TitleLarge = styled(BaseTitle)`
  font-size: 28px;
`;

export const TitleExtraLarge = styled(BaseTitle)`
  font-size: 32px;
`;

/*
 Subtitles
*/

export const BaseSubTitle = styled(Typography)`
  color: ${palette.primary.main};
  text-transform: uppercase;
  letter-spacing: 0.35px;
  margin-bottom: 4px;
  width: fit-content;
`;

export const SubTitle = styled(BaseSubTitle)`
  font-size: 10px;
  font-weight: 700;
`;

export const SubTitleLarge = styled(BaseSubTitle)`
  font-size: 12px;
  font-weight: 800;
`;

/*
 Body
*/

export const BaseBody = styled(Typography)`
  letter-spacing: 0.35px;
  color: ${palette.custom.darkGrey};
  margin-bottom: 4px;
  width: fit-content;
`;

export const Body = styled(BaseBody)`
  font-size: 14px;
  font-weight: 400;
`;

export const BodyNoTextTransform = styled(Body)`
  text-transform: none;
`;

export const BodyGrey = styled(BaseBody)`
  font-size: 14px;
  color: ${palette.custom.mediumGrey};
`;

export const BodyBold = styled(BaseBody)`
  font-size: 14px;
  font-weight: 700;
`;

export const BodyLarge = styled(BaseBody)`
  font-size: 16px;
  font-weight: 400;
`;

export const Headline = styled(BaseBody)`
  font-size: 16px;
  font-weight: 700;
`;
